<template>
  <div class="l-edit-dialog-box">
    <table class="l-info-table" style="margin-top: -10px">
      <tbody>
        <tr>
          <td>
            <span class="l-info-label">耗材编号：</span>
            <span class="l-info-content">{{ data.consumable_no }}</span>
          </td>
          <td>
            <span class="l-info-label">耗材名称：</span>
            <span class="l-info-content">{{ data.name }}</span>
          </td>
          <td>
            <span class="l-info-label">规格型号：</span>
            <span class="l-info-content">{{ data.count }}</span>
          </td>
        </tr>
        <tr v-if="data.remark">
          <td colspan="3">
            <span class="l-info-label">备注：</span>
            <span class="l-info-content">{{ data.remark }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <l-divider></l-divider>
    <el-form :model="form_data" label-width="80px" ref="form" :rules="rules" label-position="left">

      <el-form-item label="耗材总数" prop="count">

        <el-input-number v-model="form_data.count" :min="1" label="请输入本次入库的数量"></el-input-number>
        <span style="color:#aaaaaa;margin-left:5px">(本次入库)</span>
        +
        <span class="l-num">{{data.count}}</span><span style="color:#aaaaaa;margin-left:5px">(当前库存)</span>
        = <span class="l-num">{{form_data.count+data.count}}</span><span style="color:#aaaaaa;margin-left:5px">(合计)</span>
      </el-form-item>

      <el-form-item label="入库时间" prop="entry_date">
        <el-date-picker v-model="form_data.entry_date" type="date" placeholder="请选择入库时间(选填)" style="width: 100%" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>

    </el-form>

    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">提 交</el-button>
    </div>
  </div>
</template>

<script>
import CommonSelect from "../assets/CommonSelect";
import AssetsTable from "../assets/CommonTable";
import { dateToStr } from "@/utils/Fuc";
import Vue from "vue";
export default {
  name: "l-consumable-add-count",
  components: {
    [CommonSelect.name]: CommonSelect,
    [AssetsTable.name]: AssetsTable,
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    visible: {
      type: Boolean,
    },
    isDialog: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      value: "",
      loading: false,
      submitting: false,

      assets_visble: false,
      del_selected_ids: [],

      img_upload_action: Vue.$_config.api.domain + "/v1/upload/consumable_img", //照片上传地址

      consumable_no: "",
      data: {
        is_auto_no: true,
        consumable_no: "",
        name: "",
        spec: "",
        count: 1,
        remark: "",
        imgs: [],
        assets_ids: [],
      },
      form_data: {
        id: "",
        count: 1,
        entry_date: "",
      },

      imgs_list: [],

      selected_assets: [],

      preview_imgs: [],

      rules: {
        entry_date: [
          { required: true, message: "请输入入库时间", trigger: "change" },
        ],
        count: [
          {
            type: "number",
            required: true,
            message: "请输入数量",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      },
    },
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },
    //获取添加数据
    getData() {
      this.loading = true;
      //编辑获取数据
      this.$_invoke("consumable_getEditData", { id: this.$props.id })
        .then((ret) => {
          this.data = ret.form_data;
          this.imgs_list = ret.imgs_list;
          this.selected_assets = ret.selected_assets;
          this.form_data.entry_date = dateToStr(new Date(), "date");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.form_data.id = this.$props.id;

          this.$_invoke(`consumable_addCount`, this.form_data)
            .then(() => {
              this.$_msg.success("修改成功");
              this.$emit("on-success");
            })
            .finally(() => {
              this.submitting = false;
            });
        }
      });
    },
  },
};
</script>